const getLocalStorageValue = (key) => {
  const item = localStorage.getItem(key);
  if (item === null) return null;

  try {
    return item.includes('{') ? JSON.parse(item) : item;
  } catch {
    return item; // fallback in case of bad JSON
  }
};

export default getLocalStorageValue;
